/* ============================================================
   ZAMOUX Glow PDP — shared interactions (vanilla JS)
   Scoped to .zx containers. Re-inits on theme-editor events.
   ============================================================ */
(function () {
  "use strict";

  var money = function (cents) {
    if (window.Shopify && Shopify.formatMoney && window.__zxMoneyFormat) {
      return Shopify.formatMoney(cents, window.__zxMoneyFormat);
    }
    return "£" + (cents / 100).toFixed(2).replace(/\.00$/, "");
  };

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = document.getElementById("zx-toast");
    if (!t) {
      t = document.createElement("div");
      t.id = "zx-toast";
      t.className = "zx";
      t.innerHTML = '<div class="toast"><span class="check">✓</span><span class="toast-msg"></span></div>';
      document.body.appendChild(t);
    }
    t.querySelector(".toast-msg").textContent = msg || "";
    var el = t.querySelector(".toast");
    el.classList.add("show");
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { el.classList.remove("show"); }, 2300);
  }
  window.zxToast = toast;

  /* ---------- cart ---------- */
  function addToCart(variantId, qty, properties, opts) {
    opts = opts || {};
    if (!variantId) {
      toast("Connect a product to this option in the theme editor.");
      return Promise.reject("no-variant");
    }
    var body = { items: [{ id: Number(variantId), quantity: qty || 1 }] };
    if (properties && Object.keys(properties).length) body.items[0].properties = properties;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent("zx:added", { detail: data }));
        fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }));
          var bubbles = document.querySelectorAll("[data-cart-count], .cart-count-bubble, .cart-count");
          bubbles.forEach(function (b) { b.textContent = cart.item_count; });
        });
        var dest = opts.redirectTo || (opts.redirect ? "/cart" : null);
        if (dest) { window.location.href = dest; return; }
        toast(opts.message || "Added to bag");
        var drawerToggle = document.querySelector('[href="#cart-drawer"], [data-action="open-drawer"], .js-drawer-open-cart');
        if (drawerToggle) drawerToggle.click();
      })
      .catch(function (err) {
        console.warn("[zx] add to cart failed", err);
        toast((err && err.description) || "Could not add to bag");
      });
  }
  window.zxAddToCart = addToCart;

  /* ---------- gallery ---------- */
  function initGallery(root) {
    root.querySelectorAll(".gallery").forEach(function (g) {
      if (g._zx) return; g._zx = true;
      var track = g.querySelector(".gtrack");
      var slides = g.querySelectorAll(".gslide");
      var dots = g.querySelectorAll(".gdot");
      var thumbs = g.querySelectorAll(".gthumb");
      var n = slides.length, active = 0, drag = { x: 0, dx: 0, on: false };
      if (!n) return;
      function render(dx) {
        track.style.transition = drag.on ? "none" : "transform .4s cubic-bezier(.22,.9,.27,1)";
        track.style.transform = "translateX(calc(" + (-active * 100) + "% + " + (dx || 0) + "px))";
        dots.forEach(function (d, i) { d.classList.toggle("on", i === active); });
        thumbs.forEach(function (t, i) { t.classList.toggle("active", i === active); });
      }
      function go(i) { active = (i + n) % n; render(0); }
      g.querySelectorAll(".gnav.prev").forEach(function (b) { b.onclick = function () { go(active - 1); }; });
      g.querySelectorAll(".gnav.next").forEach(function (b) { b.onclick = function () { go(active + 1); }; });
      dots.forEach(function (d, i) { d.onclick = function () { go(i); }; });
      thumbs.forEach(function (t, i) { t.onclick = function () { go(i); }; });
      var main = g.querySelector(".gmain");
      function down(x) { drag = { x: x, dx: 0, on: true }; }
      function move(x) { if (!drag.on) return; drag.dx = x - drag.x; render(drag.dx); }
      function up() { if (!drag.on) return; var d = drag.dx; drag.on = false; render(0); if (d < -45) go(active + 1); else if (d > 45) go(active - 1); }
      if (main) {
        main.addEventListener("touchstart", function (e) { down(e.touches[0].clientX); }, { passive: true });
        main.addEventListener("touchmove", function (e) { move(e.touches[0].clientX); }, { passive: true });
        main.addEventListener("touchend", up);
        main.addEventListener("mousedown", function (e) { e.preventDefault(); down(e.clientX); });
        main.addEventListener("mousemove", function (e) { move(e.clientX); });
        main.addEventListener("mouseup", up);
        main.addEventListener("mouseleave", up);
      }
      render(0);
    });
  }

  /* ---------- accordion ---------- */
  function initAccordion(root) {
    root.querySelectorAll(".acc-btn").forEach(function (btn) {
      if (btn._zx) return; btn._zx = true;
      btn.addEventListener("click", function () {
        var item = btn.closest(".acc-item");
        var panel = item.querySelector(".acc-panel");
        var open = item.classList.toggle("open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        panel.style.maxHeight = open ? panel.scrollHeight + 40 + "px" : "0px";
      });
    });
  }

  /* ---------- before / after slider ---------- */
  function initBeforeAfter(root) {
    root.querySelectorAll(".ba").forEach(function (ba) {
      if (ba._zx) return; ba._zx = true;
      var before = ba.querySelector(".before");
      var divider = ba.querySelector(".divider");
      var knob = ba.querySelector(".knob");
      var dragging = false;
      function setPos(clientX) {
        var rect = ba.getBoundingClientRect();
        var p = ((clientX - rect.left) / rect.width) * 100;
        p = Math.max(4, Math.min(96, p));
        if (before) before.style.clipPath = "inset(0 " + (100 - p) + "% 0 0)";
        if (divider) divider.style.left = p + "%";
        if (knob) knob.style.left = p + "%";
      }
      function start(e) { dragging = true; setPos(e.touches ? e.touches[0].clientX : e.clientX); }
      ba.addEventListener("mousedown", start);
      ba.addEventListener("touchstart", start, { passive: true });
      window.addEventListener("mousemove", function (e) { if (dragging) setPos(e.clientX); });
      window.addEventListener("touchmove", function (e) { if (dragging) setPos(e.touches[0].clientX); }, { passive: true });
      window.addEventListener("mouseup", function () { dragging = false; });
      window.addEventListener("touchend", function () { dragging = false; });
    });
  }

  /* ---------- bestsellers rail ---------- */
  function initRail(root) {
    root.querySelectorAll(".bs-rail-wrap").forEach(function (w) {
      if (w._zx) return; w._zx = true;
      var rail = w.querySelector(".bs-rail");
      var prev = w.querySelector(".bs-nav.prev");
      var next = w.querySelector(".bs-nav.next");
      if (prev) prev.onclick = function () { rail.scrollBy({ left: -280, behavior: "smooth" }); };
      if (next) next.onclick = function () { rail.scrollBy({ left: 280, behavior: "smooth" }); };
      w.querySelectorAll(".bs-card .btn[data-variant-id]").forEach(function (b) {
        if (b._zx) return; b._zx = true;
        b.addEventListener("click", function () {
          addToCart(b.dataset.variantId, 1, {}, { message: "Added — " + (b.dataset.name || "product"), redirect: b.dataset.redirect === "true" });
        });
      });
    });
  }

  /* ---------- buy box (curl type + offers + add to cart) ---------- */
  function initBuyBox(root) {
    root.querySelectorAll(".buybox").forEach(function (bb) {
      if (bb._zx) return; bb._zx = true;
      var state = { curl: bb.dataset.defaultCurl || "", offer: "" };

      function offerEl() { return bb.querySelector('[data-offer-id="' + state.offer + '"]'); }

      function selectCurl(id) {
        state.curl = id;
        bb.querySelectorAll(".int-card").forEach(function (c) {
          c.classList.toggle("sel", c.dataset.curlId === id);
        });
      }
      function selectOffer(id) {
        state.offer = id;
        bb.querySelectorAll("[data-offer-id]").forEach(function (o) {
          o.classList.toggle("sel", o.dataset.offerId === id);
        });
        bb.querySelectorAll("[data-offer-panel]").forEach(function (p) {
          p.style.display = p.dataset.offerPanel === id ? "" : "none";
        });
        syncSelectedOffer();
      }
      function syncSelectedOffer() {
        var el = offerEl();
        if (!el) return;
        var priceC = el.dataset.priceCents, wasC = el.dataset.wasCents, isBundle = el.dataset.bundle === "true";
        var atc = bb.querySelector(".atc");
        if (atc) {
          var lbl = atc.querySelector(".atc-label");
          if (lbl) lbl.textContent = isBundle ? (bb.dataset.addBundleLabel || "Add bundle to bag") : (bb.dataset.addLabel || "Add to bag");
          var pill = atc.querySelector(".price-pill");
          if (pill) pill.innerHTML = (wasC ? "<s>" + money(wasC) + "</s> " : "") + money(priceC);
        }
        document.dispatchEvent(new CustomEvent("zx:offer", {
          detail: { id: state.offer, price: priceC, was: wasC, isBundle: isBundle, title: el.dataset.title, short: el.dataset.short }
        }));
      }

      bb.querySelectorAll(".int-card").forEach(function (c) {
        c.addEventListener("click", function () { selectCurl(c.dataset.curlId); });
      });
      bb.querySelectorAll("[data-offer-id]").forEach(function (o) {
        o.addEventListener("click", function () { selectOffer(o.dataset.offerId); });
      });

      function curlName() {
        var c = bb.querySelector('.int-card[data-curl-id="' + state.curl + '"]');
        return c ? c.querySelector("b").textContent : "";
      }

      function doAdd() {
        var el = offerEl();
        if (!el) { toast("Select an option"); return; }
        var variant = el.dataset.variantId;
        var props = {};
        if (state.curl && el.dataset.bundle !== "true") props["Curl type"] = curlName();
        var isBundle = el.dataset.bundle === "true";
        var mode = bb.dataset.afterAdd || "checkout";
        var dest = mode === "checkout" ? "/checkout" : (mode === "cart" ? "/cart" : null);
        addToCart(variant, 1, props, {
          message: "Added — " + (isBundle ? el.dataset.title : (bb.dataset.productTitle || "Curling Cream")),
          redirectTo: dest
        }).then(function () {
          var atc = bb.querySelector(".atc");
          if (atc) { atc.classList.add("added"); setTimeout(function () { atc.classList.remove("added"); }, 1700); }
        });
      }
      var atc = bb.querySelector(".atc");
      if (atc) atc.addEventListener("click", doAdd);
      bb._zxAdd = doAdd;

      if (!state.curl) { var fc = bb.querySelector(".int-card"); if (fc) state.curl = fc.dataset.curlId; }
      if (state.curl) selectCurl(state.curl);
      var def = bb.querySelector('[data-offer-id][data-default="true"]') || bb.querySelector("[data-offer-id]");
      if (def) selectOffer(def.dataset.offerId);
    });
  }

  /* ---------- sticky add-to-cart bar ---------- */
  function initSticky(root) {
    root.querySelectorAll(".stickybar").forEach(function (bar) {
      if (bar._zx) return; bar._zx = true;
      var threshold = parseInt(bar.dataset.threshold || "760", 10);
      function onScroll() {
        var on = window.scrollY > threshold;
        bar.classList.toggle("show", on);
        document.querySelectorAll(".live-activity, .zx-mystery .mystery").forEach(function (el) {
          el.classList.toggle("raised", on);
        });
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
      document.addEventListener("zx:offer", function (e) {
        var d = e.detail;
        var name = bar.querySelector(".sname b"); if (name) name.textContent = d.isBundle ? d.title : (bar.dataset.productTitle || "Curling Cream");
        var sub = bar.querySelector(".sname small"); if (sub) sub.textContent = d.short || "";
        var price = bar.querySelector(".price"); if (price) price.textContent = money(d.price);
        bar._offer = d;
      });
      var btn = bar.querySelector(".atc");
      if (btn) btn.addEventListener("click", function () {
        var bb = document.querySelector(".buybox");
        if (bb && bb._zxAdd) bb._zxAdd();
      });
    });
  }

  /* ---------- live-activity badge ---------- */
  function initLive(root) {
    root.querySelectorAll(".live-activity").forEach(function (la) {
      if (la._zx) return; la._zx = true;
      var states;
      try { states = JSON.parse(la.dataset.states || "[]"); } catch (e) { states = []; }
      if (!states.length) return;
      var nums = states.map(function (s) { return s.base + Math.floor(Math.random() * (s.range || 1)); });
      var i = 0;
      var numEl = la.querySelector(".la-num");
      var txtEl = la.querySelector(".la-label");
      function paint() {
        if (numEl) numEl.textContent = nums[i];
        if (txtEl) txtEl.textContent = " " + states[i].label;
      }
      paint();
      function schedule() {
        var gap = (Math.floor(Math.random() * 48) + 12) * 1000;
        la._t = setTimeout(function () {
          i = (i + 1) % states.length; paint();
          if (numEl) { numEl.classList.add("bump"); setTimeout(function () { numEl.classList.remove("bump"); }, 350); }
          schedule();
        }, gap);
      }
      schedule();
    });
  }

  /* ---------- mystery gift ---------- */
  function initMystery(root) {
    root.querySelectorAll(".zx-mystery").forEach(function (wrap) {
      if (wrap._zx) return; wrap._zx = true;
      var btn = wrap.querySelector(".mystery");
      var scrim = wrap.querySelector(".modal-scrim");
      var closeEls = wrap.querySelectorAll("[data-close]");
      var lock = wrap.querySelector(".m-locked");
      var unlock = wrap.querySelector(".m-unlocked");
      function eligible() {
        var bb = document.querySelector(".buybox");
        var sel = bb && bb.querySelector("[data-offer-id].sel");
        return !!(sel && (sel.dataset.bundle === "true" || sel.dataset.eligible === "true"));
      }
      function refresh() {
        var ok = eligible();
        if (btn) { btn.classList.toggle("unlocked", ok); var l = btn.querySelector(".m-btn-label"); if (l) l.textContent = ok ? "Gift unlocked" : "Mystery gift"; }
        if (lock) lock.style.display = ok ? "none" : "";
        if (unlock) unlock.style.display = ok ? "" : "none";
      }
      function open() { if (scrim) scrim.classList.add("show"); }
      function close() { if (scrim) scrim.classList.remove("show"); }
      if (btn) btn.addEventListener("click", open);
      if (scrim) scrim.addEventListener("click", function (e) { if (e.target === scrim) close(); });
      closeEls.forEach(function (c) { c.addEventListener("click", close); });
      document.addEventListener("zx:offer", refresh);
      refresh();
    });
  }

  /* ---------- run ---------- */
  function initAll(scope) {
    var root = scope || document;
    initGallery(root);
    initAccordion(root);
    initBeforeAfter(root);
    initRail(root);
    initBuyBox(root);
    initSticky(root);
    initLive(root);
    initMystery(root);
  }
  window.zxInit = initAll;

  if (document.readyState !== "loading") initAll(document);
  else document.addEventListener("DOMContentLoaded", function () { initAll(document); });

  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
